import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { ReactNode } from "react";
import { DisclosureHost } from "../../hooks/use-disclosure";
import StyledButtonV2 from "./StyledButtonV2";

interface ConfirmationModalProps {
  content?: string;
  onConfirm: () => void;
  disclosureHost: DisclosureHost;
  confirmationText?: string;
  cancelText?: string;
  title?: ReactNode;
  maxWidth?: DialogProps["maxWidth"];
  w?: string | number;
  disableCloseOutside?: boolean;
  centerButtons?: boolean;
}

const ConfirmationModal = ({
  content,
  cancelText,
  onConfirm,
  disclosureHost,
  confirmationText,
  disableCloseOutside = true,
  title,
  maxWidth,
  centerButtons = false,
}: ConfirmationModalProps) => {
  return (
    <Dialog
      open={disclosureHost.opened}
      onClose={() => (disableCloseOutside ? undefined : disclosureHost.close())}
      fullWidth={true}
      maxWidth={maxWidth}
    >
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>{content}</DialogContent>
      <DialogActions
        style={{
          paddingRight: 20,
          paddingBottom: 20,
          justifyContent: centerButtons ? "space-evenly" : "flex-end",
          gap: 1,
        }}
      >
        {/* <Button onClick={disclosureHost.close} variant="outlined">
          {cancelText ?? "Cancel"}
        </Button> */}
        <StyledButtonV2
          label={cancelText ?? "Cancel"}
          onClick={disclosureHost.close}
          variant="outlined"
        />
        {/* <Button variant="contained" onClick={onConfirm} autoFocus>
          {confirmationText ?? "Confirm"}
        </Button> */}
        <StyledButtonV2
          label={confirmationText ?? "Confirm"}
          onClick={onConfirm}
          variant="primary"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
